"use strict";

exports.__esModule = true;
exports.Schema = void 0;
var _wixDataSchemaTypes = require("@wix/wix-data-schema-types");
var _errors = require("../common/errors");
var _connection = require("./connection");
const Schema = exports.Schema = {
  make: ({
    id = '',
    fields = {}
  } = {}) => ({
    id,
    fields
  }),
  makeField: ({
    type = 'text',
    fields,
    referencedCollection
  } = {}) => ({
    type,
    fields,
    referencedCollection
  }),
  getFieldType: (schema, fieldKey) => getFieldSchema(schema, fieldKey).type,
  resolveFieldType: (schema, propConnection, schemas) => {
    const fieldType = Schema.getFieldType(schema, propConnection.fieldKey);
    const {
      schema: resolvedSchema,
      propConnection: resolvedPropConnection,
      fieldType: resolvedFieldType
    } = fieldType === _wixDataSchemaTypes.FieldType.reference ? resolveReference(schema, propConnection, schemas) : {
      schema,
      propConnection,
      fieldType
    };
    return resolvedFieldType === _wixDataSchemaTypes.FieldType.object ? getObjectFieldType(resolvedSchema, resolvedPropConnection) : resolvedFieldType;
  },
  getReferencedCollectionIds: schema => {
    const uniqueIds = Object.entries(schema.fields).reduce((acc, [_, {
      referencedCollection
    }]) => referencedCollection ? acc.add(referencedCollection) : acc, new Set());
    return Array.from(uniqueIds);
  },
  getReferencedCollectionId: (schema, fieldKey) => getFieldSchema(schema, fieldKey).referencedCollection,
  isFieldOfType: (schema, fieldKey, type) => {
    const fieldType = Schema.getFieldType(schema, fieldKey);
    return fieldType === _wixDataSchemaTypes.FieldType[type];
  }
};
const getFieldSchema = (schema, fieldKey) => schema.fields[fieldKey] ?? {};
const resolveReference = (schema, {
  fieldKey,
  path: [referencedFieldKey, ...referencedFieldPath]
}, schemas) => {
  const referencedCollectionId = Schema.getReferencedCollectionId(schema, fieldKey);
  const referencedSchema = schemas.find(({
    id
  }) => id === referencedCollectionId);
  if (referencedSchema === undefined) {
    throw _errors.CoreError.of('Referenced schema not found');
  }
  return {
    schema: referencedSchema,
    propConnection: _connection.Connection.makePropertyConnectionToField({
      fieldKey: referencedFieldKey,
      path: referencedFieldPath
    }),
    fieldType: Schema.getFieldType(referencedSchema, referencedFieldKey)
  };
};
const getObjectFieldType = (schema, {
  fieldKey,
  path
}) => {
  const fieldSchema = getFieldSchema(schema, fieldKey);
  const {
    type
  } = getObjectFieldSchema(fieldSchema, path);
  return type;
};
const getObjectFieldSchema = (fieldSchema, path) => path.reduce((currentFieldSchema, pathSegment) => {
  var _currentFieldSchema$f;
  const nextFieldSchema = (_currentFieldSchema$f = currentFieldSchema.fields) == null ? void 0 : _currentFieldSchema$f[pathSegment];
  if (nextFieldSchema === undefined) {
    throw _errors.CoreError.of('Path does not correspond field schema');
  }
  return nextFieldSchema;
}, fieldSchema);
//# sourceMappingURL=schema.js.map